/**
 * Method: GET
 */
import { InputBase } from "./common/InputBase";
import { OutputBase } from "./common/OutputBase";

export class DocAddressGetInput extends InputBase {
	id: number;
}

export class DocAddressGetOutput extends OutputBase {
	ok: {
		data: DocAddressData
	}
	error: {
	}
}

export class DocAddressData {
	company: string;
	firstName: string;
	lastName: string;
	street: string;
	postalCode: string;
	location: string;
	countryISO: string;
	phoneNumber?: string;
	lat: number;
	lon: number;
}